module.exports = __webpack_public_path__ + "static/media/agenda.fec7c8ab.svg";